import React from "react";
import PropTypes from "prop-types";
import ClienteDesktop from "./ClienteDesktop";

function PositivacaoCategory({ app, config }) {
  return <ClienteDesktop app={app} config={config} />;
}

PositivacaoCategory.defaultProps = {
  app: null,
  config: {},
};

PositivacaoCategory.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default PositivacaoCategory;
